module.exports = __webpack_public_path__ + "static/media/image-first-strip.12ce4acb.svg";